import { createRemoveCollectionSyncSlice } from '@sonar-software/xuder';
import { notificationsGetSlice } from '../@async/get';
import { NotificationsName } from '../name';

export const removeNotifications = createRemoveCollectionSyncSlice({
	hasRequest: false,
	name: NotificationsName,
	state: notificationsGetSlice.asyncState
});
